import React from 'react';
import { useNavigate } from 'react-router-dom';
import FeaturedSolutions, { AgilysysLogo, GreenDivider } from '../components/FeaturedSolutions';

// Shared featured item sets
function InfoGenesisItem() {
  const navigate = useNavigate();
  return (
    <div className="featured-item" onClick={() => navigate('/solutions/info-genesis')}>
      <div className="item-head"><AgilysysLogo />InfoGenesis</div>
      <img src="/assets/higher-ed/solutions/tablet-info-genesis.png" alt="" />
    </div>
  );
}
function IGOnDemandItem() {
  const navigate = useNavigate();
  return (
    <div className="featured-item" onClick={() => navigate('/solutions/ig-on-demand')}>
      <div className="item-head"><AgilysysLogo />IG OnDemand</div>
      <img src="/assets/higher-ed/solutions/app-ondemand-food.png" alt="" />
    </div>
  );
}
function IGKioskItem() {
  const navigate = useNavigate();
  return (
    <div className="featured-item" onClick={() => navigate('/solutions/ig-kiosk')}>
      <div className="item-head"><AgilysysLogo />IG Kiosk</div>
      <img src="/assets/higher-ed/solutions/kiosk-food-order-tall.png" alt="" />
    </div>
  );
}
function DigitalMenuItem() {
  const navigate = useNavigate();
  return (
    <div className="featured-item" onClick={() => navigate('/solutions/digital-menu')}>
      <div className="item-head"><AgilysysLogo />IG Digital Menu Board</div>
      <img src="/assets/higher-ed/solutions/digital-menu.png" alt="" />
    </div>
  );
}

const PAGE_CONFIG = {
  kitchen: {
    pageClass: 'kitchenPage',
    header: 'Campus Dining',
    topic: 'Kitchen',
    text: 'Whether diners place their orders via the POS, a self-service kiosk, their desktop or mobile phones, all orders are routed to the kitchen and managed using the IG Kitchen Display System to ensure quick and accurate order delivery, with Eatec inventory ensuring every ingredient is fresh and on-hand.',
    items: (navigate) => (
      <>
        <div className="featured-item" onClick={() => navigate('/solutions/ig-kds')}>
          <img src="/assets/higher-ed/solutions/tablet-kitchen-system.png" alt="" />
          <div className="item-head"><AgilysysLogo />IG KDS</div>
        </div>
        <div className="featured-item" onClick={() => navigate('/solutions/eatec')}>
          <img src="/assets/higher-ed/solutions/tablet-eatec-2.png" alt="" />
          <div className="item-head"><AgilysysLogo />Eatec</div>
        </div>
      </>
    ),
  },
  'dining-hall': {
    pageClass: 'diningHallPage',
    header: 'Campus Dining',
    topic: 'Dining Hall',
    text: "Keep staff informed of student's seating choices, food preferences, allergies, and more.\n\nTechnology enables fast, fresh, convenient delivery of food, while supporting rotating and flexible menus.\n\nGrab-and-go food and beverage options including mobile barcode scanning with advanced self-service check-out.",
    items: () => (
      <>
        <InfoGenesisItem />
        <IGOnDemandItem />
        <IGKioskItem />
        <DigitalMenuItem />
      </>
    ),
  },
  'food-court': {
    pageClass: 'foodCourtPage',
    header: 'Campus Dining',
    topic: 'Food Court',
    text: 'In higher education environments speed matters most.\n\nAgilysys InfoGenesis POS provides diners with convenient self-service ordering and quick payment options.\n\nThe result is fast, accurate and on-time food delivery to keep service moving.',
    items: () => (
      <>
        <InfoGenesisItem />
        <IGOnDemandItem />
        <IGKioskItem />
        <DigitalMenuItem />
      </>
    ),
  },
  seats: {
    pageClass: 'seatsPage',
    header: 'Athletics',
    topic: 'Seats',
    hasSeatsGraphic: true,
    text: 'Delight students with food and beverage at-a-click advanced ordering for pick-up while enjoying the big game or provide them with the ability to get orders delivered directly to their seat.\n\nFast, easy, mobile ordering and payment drives order volume and grows F&B revenue.',
    items: (navigate) => (
      <div className="featured-item" onClick={() => navigate('/solutions/ig-on-demand')}>
        <div className="item-head"><AgilysysLogo />IG OnDemand</div>
        <img src="/assets/higher-ed/solutions/app-ondemand-food.png" alt="" />
      </div>
    ),
  },
  concessions: {
    pageClass: 'concessionsPage',
    header: 'Athletics',
    topic: 'Concessions',
    text: 'Enhance the game day experience and ensure fans never miss a play with fast, easy, mobile and self-service ordering and payment to drive increased order volume, improve check size and grow F&B revenue.',
    items: () => (
      <>
        <InfoGenesisItem />
        <IGOnDemandItem />
        <IGKioskItem />
        <DigitalMenuItem />
      </>
    ),
  },
  'gift-shop': {
    pageClass: 'bookstorePage',
    header: 'Main Campus',
    topic: 'Gift Shop',
    text: "Maximize school spirit by keeping hats, hoodies, mugs, apparel, and accessories in stock at the right price for every student.\n\nWith InfoGenesis POS and Eatec procurement and perpetual inventory system, not only will you have the items your students desire, but they can also seamlessly pay by charging to their student card, credit cards, gift cards or cash.",
    items: (navigate) => (
      <>
        <div className="featured-item" onClick={() => navigate('/solutions/info-genesis')}>
          <img src="/assets/higher-ed/solutions/InfoGenesis3.png" alt="" />
          <div className="item-head"><AgilysysLogo />InfoGenesis</div>
        </div>
        <div className="featured-item" onClick={() => navigate('/solutions/eatec')}>
          <img src="/assets/higher-ed/solutions/tablet-eatec.png" alt="" />
          <div className="item-head"><AgilysysLogo />Eatec</div>
        </div>
      </>
    ),
  },
  'classrooms': {
    pageClass: 'classroomsPage',
    header: 'Main Campus',
    topic: 'Classrooms & Library',
    text: 'Offer your students a complete contactless self-service F&B ordering solution that offers an intuitive diner-facing order and pay experience.\n\nIG OnDemand allows diners to place and pay for orders using their own device \u2013 phone, tablet, laptop \u2013 for pick-up or delivery.\n\nThe result is a more seamless experience and enhanced customer service.',
    items: (navigate) => (
      <div className="featured-item" onClick={() => navigate('/solutions/ig-on-demand')}>
        <div className="item-head"><AgilysysLogo />IG OnDemand</div>
        <img src="/assets/higher-ed/solutions/app-ondemand-food.png" alt="" />
      </div>
    ),
  },
  'shipping-receiving': {
    pageClass: 'shippingPage',
    header: 'Main Campus',
    topic: 'Shipping & Receiving',
    text: "Don't let unexpected food costs eat away at your profits. Manage inventory on-hand by freshness, warehouse, location and venue, as well as automated replenishment requisitions to optimize availability.\n\nEatec Mobile speeds receiving and stock movements so every inquiry is accurate and each ingredient is where you need it when you need it.",
    items: (navigate) => (
      <div className="featured-item" onClick={() => navigate('/solutions/eatec')}>
        <div className="item-head"><AgilysysLogo />Eatec</div>
        <img src="/assets/higher-ed/solutions/tablet-eatec.png" alt="" />
      </div>
    ),
  },
};

function DetailPage({ pageId }) {
  const navigate = useNavigate();
  const config = PAGE_CONFIG[pageId];

  if (!config) {
    return <div className="page"><div className="page-header">Not Found</div></div>;
  }

  const { pageClass, header, topic, text, hasSeatsGraphic, items } = config;

  return (
    <div className={`page ${pageClass}`}>
      {hasSeatsGraphic && <div className="seats-graphic" />}
      <div className="page-header">{header}</div>
      <div className="text-wrapper">
        <div className="top">
          <div className="topic-header">{topic}</div>
          <GreenDivider />
        </div>
        <div className="std-text">{text}</div>
      </div>
      <FeaturedSolutions>
        {items(navigate)}
      </FeaturedSolutions>
    </div>
  );
}

export default DetailPage;
